import React from 'react';
//styles
import './index.scss';
//helpers
import { findData } from '../../../helper/dataFinder';
import ShowForPermission from '../../../../ShowForPermission';

const TableBody = props => {
  const { dataIndex, columns, loading, currentPage, pageSize, action } = props;
  return (
    <tbody className='tBody'>
      {loading ? (
        <h1 style={{ color: 'blue' }}>در حال دریافت اطلاعات...</h1>
      ) : dataIndex.length === 0 ? (
        <h1 style={{ color: 'red' }}>داده ای برای نمایش وجود ندارد</h1>
      ) : (
        dataIndex?.map((data, index) => (
          <tr key={index}>
            {columns.map(column => {
              if (column.isRowNumber) {
                return (
                  <td key={column.dataIndex + index}>
                    {(currentPage - 1) * pageSize + index + 1}
                  </td>
                );
              } else if (typeof column.action == 'function') {
                return (
                  <td key={column.dataIndex + index}>
                    {column.action(data, action)}
                  </td>
                );
              } else if (typeof column.render == 'function') {
                return (
                  <td key={column.dataIndex + index}>
                    {column.render(findData(data, column.dataIndex), data)}
                  </td>
                );
              } else if (column.permission) {
                return (
                  <ShowForPermission permission={column.permission}>
                    <td key={column.dataIndex + index}>
                      {findData(data, column.dataIndex)}
                    </td>
                  </ShowForPermission>
                );
              } else {
                return (
                  <td key={column.dataIndex + index}
                    className={`${column.dataIndex === 'trackingNumber' ? 'direction-ltr' : ''}`}>
                    {findData(data, column.dataIndex)}
                  </td>
                );
              }
            })}
          </tr>
        ))
      )}
    </tbody>
  );
};

export default TableBody;
